<template>
  <ul :class="{'round': round, 'gray': gray}" class="socials">
    <li v-if="!exclude.includes('facebook')" class="social">
      <component
        :is="component"
        class="social-link"
        href="https://www.facebook.com/delayfix/"
        target="_blank"
        @click="$emit('click', 'facebook')"
      >
        <div class="text">Facebook</div>
        <svg
          class="icon"
          width="0"
          height="0"
          viewBox="0 0 32 31"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <path
              d="M15.8264195,0.0980292683 C7.3347122,0.0980292683 0.450809756,6.98318049 0.450809756,15.473639 C0.450809756,23.9653463 7.3347122,30.848 15.8264195,30.848 C24.3181268,30.848 31.2020293,23.9653463 31.2020293,15.473639 C31.2020293,6.98318049 24.3175024,0.0980292683 15.8264195,0.0980292683 Z M19.8955707,15.4093268 L17.2331707,15.4093268 C17.2331707,19.663922 17.2331707,24.9044293 17.2331707,24.9044293 L13.2870244,24.9044293 C13.2870244,24.9044293 13.2870244,19.7176195 13.2870244,15.4093268 L11.4101073,15.4093268 L11.4101073,12.0569756 L13.2870244,12.0569756 L13.2870244,9.88472195 C13.2870244,8.32999024 14.0250537,5.90298537 17.2700098,5.90298537 L20.1921561,5.91422439 L20.1921561,9.17041951 C20.1921561,9.17041951 18.4151415,9.17041951 18.070478,9.17041951 C17.7239415,9.17041951 17.2337951,9.34337561 17.2337951,10.0826537 L17.2337951,12.0576 L20.2421073,12.0576 L19.8955707,15.4093268 Z"
              fill-rule="nonzero"
            />
          </g>
        </svg>
      </component>
    </li>
    <li v-if="!exclude.includes('twitter')" class="social">
      <component
        :is="component"
        class="social-link"
        href="https://twitter.com/opoznionysamolo"
        target="_blank"
        @click="$emit('click', 'twitter')"
      >
        <div class="text">Twitter</div>
        <svg
          class="icon"
          width="0"
          height="0"
          viewBox="0 0 32 31"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <path
              d="M15.7532488,0.0980292683 C7.26154146,0.0980292683 0.377639024,6.98318049 0.377639024,15.473639 C0.377639024,23.9653463 7.26091707,30.848 15.7532488,30.848 C24.2462049,30.848 31.1288585,23.9653463 31.1288585,15.473639 C31.1288585,6.98318049 24.2455805,0.0980292683 15.7532488,0.0980292683 Z M19.8860878,24.4298927 C19.2517073,24.4298927 15.7445073,24.3468488 14.8485073,24.3468488 C13.9531317,24.3468488 9.28394146,22.8907707 9.28394146,17.7539122 C9.28394146,16.8391805 9.28331707,15.9194537 9.28081951,15.0040976 C9.27707317,14.1505561 9.25959024,13.2982634 9.25646829,12.4503415 C9.2558439,12.2030829 9.25459512,11.9552 9.25334634,11.7079415 C9.24710244,10.4142049 9.13783415,8.95750244 9.55367805,7.71496585 C9.87211707,6.76714146 10.6251317,6.38813659 11.5529756,6.38813659 C13.7970341,6.38813659 13.9468878,8.67590244 13.9531317,10.9736585 L20.4386732,10.9736585 C21.4657951,10.9736585 22.2325463,12.0151415 22.2325463,13.6092098 C22.2325463,15.2020293 20.5704195,15.5591805 19.7006439,15.5591805 L13.8813268,15.5591805 C13.8519805,16.534478 13.8201366,17.3287024 13.8201366,17.8113561 C13.8201366,18.8259902 14.2166244,19.9249171 16.6948293,19.9249171 L20.177678,19.9249171 C21.0474537,19.9249171 22.3374439,20.5836488 22.3374439,22.4237268 C22.3374439,24.2613073 20.5185951,24.4298927 19.8860878,24.4298927 Z"
              fill-rule="nonzero"
            />
          </g>
        </svg>
      </component>
    </li>
    <li v-if="!exclude.includes('instagram')" class="social">
      <component
        :is="component"
        class="social-link"
        href="https://www.instagram.com/delayfix/"
        target="_blank"
        @click="$emit('click', 'instagram')"
      >
        <div class="text">Instagram</div>
        <svg
          class="icon"
          width="0"
          height="0"
          viewBox="0 0 31 31"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g fill-rule="nonzero">
              <circle cx="15.4526829" cy="15.6097561" r="2.74731707"/>
              <path
                d="M18.8868293,8.86634146 L12.0185366,8.86634146 C11.0195122,8.86634146 10.1453659,9.17853659 9.58341463,9.7404878 C9.02146341,10.302439 8.70926829,11.1765854 8.70926829,12.1756098 L8.70926829,19.0439024 C8.70926829,20.0429268 9.02146341,20.9170732 9.64585366,21.5414634 C10.2702439,22.1034146 11.0819512,22.4156098 12.0809756,22.4156098 L18.8868293,22.4156098 C19.8858537,22.4156098 20.76,22.1034146 21.3219512,21.5414634 C21.9463415,20.9795122 22.2585366,20.1053659 22.2585366,19.1063415 L22.2585366,12.2380488 C22.2585366,11.2390244 21.9463415,10.4273171 21.3843902,9.80292683 C20.76,9.17853659 19.9482927,8.86634146 18.8868293,8.86634146 Z M15.4526829,19.8556098 C13.08,19.8556098 11.2068293,17.92 11.2068293,15.6097561 C11.2068293,13.2370732 13.142439,11.3639024 15.4526829,11.3639024 C17.7629268,11.3639024 19.7609756,13.2370732 19.7609756,15.6097561 C19.7609756,17.982439 17.8253659,19.8556098 15.4526829,19.8556098 Z M19.8858537,12.1756098 C19.3239024,12.1756098 18.8868293,11.7385366 18.8868293,11.1765854 C18.8868293,10.6146341 19.3239024,10.177561 19.8858537,10.177561 C20.4478049,10.177561 20.884878,10.6146341 20.884878,11.1765854 C20.884878,11.7385366 20.4478049,12.1756098 19.8858537,12.1756098 Z"
              />
              <path
                d="M15.577561,0.124878049 C7.08585366,0.124878049 0.217560976,6.99317073 0.217560976,15.484878 C0.217560976,23.9765854 7.08585366,30.844878 15.577561,30.844878 C24.0692683,30.844878 30.937561,23.9765854 30.937561,15.484878 C31,6.99317073 24.0692683,0.124878049 15.577561,0.124878049 Z M23.7570732,19.1063415 C23.7570732,20.542439 23.257561,21.7912195 22.3834146,22.6653659 C21.5092683,23.5395122 20.2604878,23.9765854 18.8868293,23.9765854 L12.0809756,23.9765854 C10.7073171,23.9765854 9.45853659,23.5395122 8.58439024,22.6653659 C7.64780488,21.7912195 7.21073171,20.542439 7.21073171,19.1063415 L7.21073171,12.2380488 C7.21073171,9.36585366 9.14634146,7.36780488 12.0809756,7.36780488 L18.9492683,7.36780488 C20.3853659,7.36780488 21.5717073,7.86731707 22.4458537,8.74146341 C23.32,9.61560976 23.7570732,10.8019512 23.7570732,12.2380488 L23.7570732,19.1063415 Z"
              />
            </g>
          </g>
        </svg>
      </component>
    </li>
    <li v-if="!exclude.includes('linkedIn')" class="social">
      <component
        :is="component"
        class="social-link"
        href="https://www.linkedin.com/company/passenger-rights/"
        target="_blank"
        @click="$emit('click', 'linkedIn')"
      >
        <div class="text">LinkedIn</div>
        <svg
          class="icon"
          width="0"
          height="0"
          viewBox="0 0 32 31"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g fill-rule="nonzero">
              <path
                d="M15.680078,0.0967804878 C7.18837073,0.0967804878 0.304468293,6.98068293 0.304468293,15.4723902 C0.304468293,23.9653463 7.18837073,30.848 15.680078,30.848 C24.1705366,30.848 31.054439,23.9653463 31.054439,15.4723902 C31.054439,6.98130732 24.1699122,0.0967804878 15.680078,0.0967804878 Z M24.2435902,22.940722 C24.2435902,23.6250537 23.6753951,24.1782634 22.9754537,24.1782634 L8.35348293,24.1782634 C7.65229268,24.1782634 7.08534634,23.6244293 7.08534634,22.940722 L7.08534634,8.14954146 C7.08534634,7.46645854 7.65229268,6.912 8.35348293,6.912 L22.9748293,6.912 C23.6747707,6.912 24.2429659,7.46708293 24.2429659,8.14954146 L24.2429659,22.940722 L24.2435902,22.940722 Z"
              />
              <path
                d="M18.6471805,13.3875512 C17.2728976,13.3875512 16.6566244,14.142439 16.311961,14.6744195 L16.311961,14.7000195 L16.2951024,14.7000195 C16.3013463,14.6925268 16.3075902,14.683161 16.311961,14.6744195 L16.311961,13.5704976 L13.7207415,13.5704976 C13.7550829,14.3010341 13.7207415,21.3653854 13.7207415,21.3653854 L16.311961,21.3653854 L16.311961,17.0115122 C16.311961,16.7773659 16.3288195,16.5469659 16.3975024,16.3796293 C16.5854439,15.9150829 17.0119024,15.4305561 17.7268293,15.4305561 C18.6659122,15.4305561 19.0405463,16.1461073 19.0405463,17.1938341 L19.0405463,21.364761 L21.6317659,21.364761 L21.6317659,16.896 C21.6311415,14.500839 20.3517659,13.3875512 18.6471805,13.3875512 Z"
              />
              <path
                d="M11.0077659,9.81041951 C10.1217561,9.81041951 9.54107317,10.3936 9.54107317,11.158478 C9.54107317,11.9058732 10.1030244,12.5059122 10.9734244,12.5059122 L10.9902829,12.5059122 C11.8937756,12.5059122 12.4563512,11.9058732 12.4563512,11.158478 C12.4394927,10.3936 11.8944,9.81041951 11.0077659,9.81041951 Z"
              />
              <rect
                x="9.69529756"
                y="13.5704976"
                width="2.5918439"
                height="7.7948878"
              />
            </g>
          </g>
        </svg>
      </component>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    round: {
      type: Boolean,
      default: false
    },
    gray: {
      type: Boolean,
      default: false
    },
    exclude: {
      type: Array,
      default: () => []
    },
    component: {
      type: String,
      default: 'a'
    }
  }
}
</script>

<style lang="scss" scoped>
  .social {
    width: 100%;

    .round & {
      width: auto;
    }
  }

  .social-link {
    display: inline-block;
    margin-bottom: 1.5em;
    color: $beige;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;

    .icon {
      display: none;
      width: 100%;
      height: 100%;
    }

    .round & {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin: 0 6px;
      display: flex;
      justify-content: center;
      align-items: center;

      .text {
        display: none;
      }

      .icon {
        display: block;

        > * {
          fill: $teal;
        }
      }
    }

    .gray & {
      width: 22px;
      height: 22px;

      .text {
        display: none;
      }

      .icon {
        display: block;

        > * {
          fill: $gray-light-text;
        }
      }
    }

    .gray &,
    .round & {
      @include media-down(md) {
        height: 40px;
        width: 40px;
      }
    }
  }
</style>
